import {ObjectUtil} from '../../util/object-util';
import {PrivateNoteLocation} from '../../enum/private-note-location';

export class PrivateNote {
  id: string = null;
  userId: string = null;
  proposalId: string = null;
  offerId: string = null;
  location: PrivateNoteLocation = null;
  note: string = null;

  constructor(object?: Object) {
    ObjectUtil.assign(this, object);
  }
}
